import { render, staticRenderFns } from "./TruthDare.vue?vue&type=template&id=53bb36c8&scoped=true"
import script from "./TruthDare.vue?vue&type=script&lang=js"
export * from "./TruthDare.vue?vue&type=script&lang=js"
import style0 from "./TruthDare.vue?vue&type=style&index=0&id=53bb36c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bb36c8",
  null
  
)

export default component.exports